import { Landmark, CreditCard } from 'lucide-react'

export function resolvePaymentBrand (methodType, methodLabel) {
  if (String(methodType || '').toLowerCase() === 'ach') return 'bank'
  const label = String(methodLabel || '').toLowerCase()
  if (label.includes('visa')) return 'visa'
  if (label.includes('master')) return 'mastercard'
  if (label.includes('amex') || label.includes('american express')) return 'amex'
  if (label.includes('discover')) return 'discover'
  return 'card'
}

export default function PaymentMethodBadge ({ methodType, methodLabel, last4 }) {
  const brand = resolvePaymentBrand(methodType, methodLabel)
  const digits = last4 ? String(last4) : ''
  const brandName = brand === 'bank' ? 'Bank' : brand === 'card' ? 'Card' : brand
  return (
    <span className='inline-flex items-center gap-2 min-w-0'>
      <BrandMark brand={brand} />
      {digits
        ? <span className='text-sm text-slate-700 dark:text-slate-200 truncate'>···{digits}</span>
        : null}
      <span className='sr-only'>{brandName}{digits ? ` ending ${digits}` : ''}</span>
    </span>
  )
}

function BrandMark ({ brand }) {
  if (brand === 'bank') {
    return (
      <span className='inline-flex items-center gap-1 h-6 px-1.5 rounded bg-slate-700 text-white text-[10px] font-bold tracking-wide'>
        <Landmark size={12} aria-hidden />
        BANK
      </span>
    )
  }
  if (brand === 'visa') {
    return (
      <span className='inline-flex items-center justify-center h-6 min-w-[2.75rem] px-1.5 rounded bg-[#1A1F71] text-white text-[11px] font-extrabold italic tracking-tight'>
        VISA
      </span>
    )
  }
  if (brand === 'mastercard') {
    return (
      <span className='inline-flex items-center h-6 px-1.5 rounded bg-black gap-0.5' aria-label='Mastercard'>
        <span className='w-3 h-3 rounded-full bg-[#EB001B]' />
        <span className='w-3 h-3 rounded-full bg-[#F79E1B] -ml-1.5 opacity-90' />
      </span>
    )
  }
  if (brand === 'amex') {
    return (
      <span className='inline-flex items-center justify-center h-6 min-w-[2.75rem] px-1.5 rounded bg-[#2E77BC] text-white text-[9px] font-extrabold tracking-wide'>
        AMEX
      </span>
    )
  }
  if (brand === 'discover') {
    return (
      <span className='inline-flex items-center justify-center h-6 min-w-[2.75rem] px-1.5 rounded bg-[#FF6000] text-white text-[8px] font-extrabold tracking-wide'>
        DISC
      </span>
    )
  }
  return (
    <span className='inline-flex items-center gap-1 h-6 px-1.5 rounded bg-slate-800 text-white text-[10px] font-bold'>
      <CreditCard size={12} aria-hidden />
      CARD
    </span>
  )
}
